import React from "react";

export const GoogleOAuth = ({ BeURL }) => {

    const handleGoogleLogin = () => {
        window.open(`${BeURL}/auth/google`, "_self");
    };

    return (
        <button
            onClick={handleGoogleLogin}
            className="flex items-center bg-white justify-center gap-3 w-full  py-2.5 rounded-md transition"
        >
            <img
                src="https://www.svgrepo.com/show/475656/google-color.svg"
                alt="google"
                className="w-5 h-5"
            />

            <span className="text-gray-700 font-medium">
                Continue with Google
            </span>
        </button>
    );
};